import { initErrorLogger } from 'scripts/errorLogger';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import featuresApi from 'api/requests/features';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Importação correta

window.featuresFlagEnabled = import.meta.env.VITE_FEATURE_FLAG_ENABLED
window.features = []

async function getFeaturesFlags() {
  try {
    const { data } = await featuresApi.flags()
    const enabledFeatures = data.data.filter(el => el.enabled)

    enabledFeatures.map(el => {
      window.features = [...window.features, el.name]
    })
  } catch (error) {
    window.features = []
  }
}

if (window.featuresFlagEnabled) {
    getFeaturesFlags()
}

initErrorLogger();

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();